import React, { useState, useContext, useEffect, Fragment, useRef } from 'react'
import { Link, useParams } from "react-router-dom";
import Swal from 'sweetalert2'
import { useHotkeys } from 'react-hotkeys-hook';

//Contexto
import ConexContext from "../context/conex/ConexContext";

//SVG
import { ReactComponent as WriteIcon } from "../assets/img/iconos/acae_edit_1.svg";
import { ReactComponent as TrashIcon } from "../assets/img/iconos/acae_trash.svg";
import { ReactComponent as DojoIcon } from "../assets/img/iconos/acae_dojo.svg";
import { ReactComponent as MasIcon } from "../assets/img/iconos/acae_add.svg";
import { ReactComponent as AcaeArrow } from "../assets/img/iconos/acae_arrow.svg";
import { ReactComponent as AcaeIcon } from "../assets/img/iconos/acae_flower_fill.svg";
import { ReactComponent as OptionsIcon } from "../assets/img/iconos/acae_options.svg";

//imagenes
// import loadingGif from "../assets/img/loading.gif"
import desc from "../assets/img/desc.svg"
import asc from "../assets/img/asc.svg"
import pliega from "../assets/img/pliega.svg";
import despliega from "../assets/img/despliega.svg";
//modulos
import DojosMod from './DojosMod'
import Paginacion from './comun/Paginacion';
import MenuToggle from './comun/menuToggle';
import FloatingMenu from './comun/FloatingMenu';


const Dojos = ({ setSidebar, Sidebar }) => {
	const {
		peticion,
		loc,
		perfil_admin,
		perfil_adm_asoc,
		perfil_adm_dojo,
		perfil_asoc,
		perfil_dojo,
		Cargando
	} = useContext(ConexContext)//contexto
	const { idReg, asoc, lang } = useParams();
	//STATES
	const [Detalles, setDetalles] = useState(0)// id del que se debe mostrar detalles
	const [VerMod, setVerMod] = useState(0)// para ver el modal de Ficheros
	const [List, setList] = useState([])// listado
	const [NRes, setNRes] = useState(0)// Nº de registros con filtro
	const [NTot, setNTot] = useState(0)// Nº de registros con filtro
	const [ListParams, setListParams] = useState({
		num: 15,
		orden: 'nombre',
		filtro: '',
		ini: 0,
		nomAso: '',
		idAsoc: 0,
		idReg: 0
	})
	const [activeMenu, setActiveMenu] = useState(null)//menu flotante
	const menuRefs = useRef({})//referencias a los menus flotantes

	//atajos de teclado
	useHotkeys('alt+n', () => { if (perfil_admin | perfil_adm_asoc) setVerMod(-1) })


	//borra un registro concreto
	const borrar = async (id) => {
		const pet = await peticion('/dojos/del', {
			method: 'POST', json: {
				id: id
			}
		})
		if (pet?.estado ?? 0 === 9) {
			Swal.fire({
				title: loc("El dojo no se puede eliminar"),
				text: loc("El dojo tiene asociados o cuotas asignadas, por lo que no puede ser eliminado"),
				showConfirmButton: true,
				icon: 'error',
			})
			return
		}
		if (pet?.estado ?? true)//algún error 
			return;
		Swal.fire({
			title: loc("Dojo eliminado"),
			showConfirmButton: false,
			icon: 'success',
			timer: 1500
		})
		setListParams({ ...ListParams })
	}

	//cambia el orden
	const orden = (campo) => {
		if (ListParams.orden === campo)
			setListParams({ ...ListParams, orden: campo + ' DESC' })
		else
			setListParams({ ...ListParams, orden: campo })
	}

	//EFFECT
	useEffect(() => {
		//listado en sí de los asociados
		const listar = async () => {

			const pet = await peticion('/dojos/?' +
				`ini=${ListParams.ini}&` +
				`pag=${ListParams.num}&` +
				`orden=${ListParams.orden}&` +
				`filtro=${ListParams.filtro}&` +
				`idAsoc=${ListParams.idAsoc}`
			)
			if (pet?.estado ?? false)//algún error 
				return null;
			setList(pet.res)
			setNRes(pet.nRes)
			setNTot(pet.nTot)
		}
		//peticiíon de nombre de la asociación
		const getAsoc = async (id) => {
			const pet = await peticion('/asocs/ver?id=' + id)
			if (pet?.estado ?? false)//algún error 
				return;
			setListParams((prev) => ({
				...prev,
				idAsoc: pet?.res?.idAsoc ?? id,
				nomAso: pet?.res?.nombre ?? ''
			}))
		}
		//devuelve la pos de un id
		const getPosicion = async (id) => {
			const pet = await peticion('/dojos/posicion?' +
				`id=${id}&` +
				`orden=${ListParams.orden}&` +
				`filtro=${ListParams.filtro}&` +
				`idAsoc=${ListParams.idAsoc}`)
			if (pet?.estado ?? false)//algún error 
				return;
			if (pet?.res?.pos ?? false) {
				const pos = pet.res.pos - (pet.res.pos - 1) % ListParams.num - 1
				if (pos !== ListParams.ini)
					setListParams((prev) => ({
						...prev,
						ini: pet.res.pos - (pet.res.pos - 1) % ListParams.num - 1,
						idReg: id
					}))
				else setListParams((prev) => ({ ...prev, idReg: id }))

			}
		}
		let id = parseInt(asoc.split('_')[1])//asoc_xxx
		const idAsoc = (isNaN(id) ? 0 : id)//id del dojo de la url en número
		const idRegN = (isNaN(parseInt(idReg)) ? 0 : parseInt(idReg))//id del asoc de la url en número
		// console.log('idRegN',idRegN,ListParams.idReg);
		if (ListParams.idAsoc !== idAsoc)//hay una asoc nueva en la url
			getAsoc(idAsoc);//peticion asoc y recarga de ListParams -> en la siguente pasaremos por listar
		else if (ListParams.idReg !== idRegN)// hay que listar un asociado concreto
			getPosicion(idRegN)
		else {
			listar()
		}
		// eslint-disable-next-line
	}, [ListParams, asoc, idReg])

	// Comprobamos si es admin/adminDojo para mostrar u ocultar los campos
	const mostrarCampos = perfil_admin || perfil_adm_asoc === true || perfil_adm_dojo === true

	function getDojoActions(elem) {
		const acciones = [];

		if ((mostrarCampos) && (perfil_admin || (perfil_adm_asoc && (elem.cfAsoc === perfil_asoc)) || (perfil_adm_dojo && (elem.idDojo === perfil_dojo)))) {
			acciones.push({
				label: loc("Ver asociados de ") + elem.nombre,
				icon: <AcaeArrow className="icon" />,
				link: true,
				href: `/${lang}/app/asociados/dojo_${elem.idDojo}`,
			});
		}
		if (mostrarCampos && (perfil_admin || (perfil_adm_asoc && (elem.cfAsoc === perfil_asoc)))) {
			acciones.push({
				label: loc("Ver asociación"),
				icon: <AcaeArrow className="icon" />,
				link: true,
				href: `/${lang}/app/asociaciones/${elem.cfAsoc}`,
			});

		}
		if (mostrarCampos && (perfil_admin || (perfil_adm_asoc && (elem.cfAsoc === perfil_asoc)) || (perfil_adm_dojo && (elem.idDojo === perfil_dojo)))) {
			acciones.push({
				label: loc("Modificar dojo"),
				icon: <WriteIcon className="icon" />,
				onClick: () => setVerMod(elem.idDojo),
			});
			acciones.push({
				label: loc("Eliminar dojo"),
				icon: <TrashIcon className="icon" />,
				onClick: () =>
					Swal.fire({
						title: loc("¿Seguro que quieres eliminar el dojo?"),
						showCancelButton: true,
						confirmButtonText: loc("Sí"),
						cancelButtonText: loc("No"),
						icon: "question",
					}).then((result) => {
						if (result.isConfirmed) borrar(elem.idDojo);
					}),
			});
		}

		return acciones;
	}

	const accionesPorDojo = List.reduce((acc, elem) => {
		acc[elem.idDojo] = getDojoActions(elem);
		return acc;
	}, {});
	
	const toggleMenu = (id) => {
		setActiveMenu(activeMenu === id ? null : id);
	};

	const showAcciones = Object.values(accionesPorDojo).some(a => a.length > 0);		

	return (
		<>
			<div className='content-wrapper main-section' id='dojos'>
				<header className='backdrop space-between'>
					<div className='flex-row-item'>
						<DojoIcon className='section-icon' alt='Dojos' />
						<h1>
							{loc('Dojos') + (ListParams.nomAso ? `${loc(" de")} ${ListParams.nomAso}` : '')}
						</h1>
					</div>
					<MenuToggle Sidebar={Sidebar} setSidebar={setSidebar} />

				</header>
				{/* <div className="col-xs-9">

					<div className="col-xs-12 titularh2">
						<img src={logo} alt='asoc' />
						<h2>{loc('Dojos')}{(ListParams?.idAsoc ?? false) ? ` ${loc('de')}: ${ListParams?.nomAso ?? ''}` : ''}</h2>
					</div>
				</div> */}

				{Cargando && !VerMod ? (
					<div className="backdrop precarga">
						<div className="loader-wrapper">
							<div className="circle-wrapper">
								<div className="circle-1" />
								<div className="circle-2" />
								<div className="circle-3" />
								<div className="circle-4" />
								<div className="circle-5" />
							</div>
							<AcaeIcon />
						</div>
						<span>
							{loc("Cargando...")}
						</span>
					</div>
				) : (
					<div className='backdrop content-wrapper'>
						<div className='filtering'>
							<Paginacion
								nrPag={List.length}
								NRes={NRes}
								NTot={NTot}
								Ini={ListParams.ini}
								setListParams={setListParams}
								Num={ListParams.num}
								Filtro={ListParams.filtro}
							/>
						</div>

						<div className='table-container'>
							<table className='table-dojos'>
								<thead className='table-headers'>
									<tr>
										{showAcciones &&
											<th className="tiny-column"></th>
										}
										<th>
											<button onClick={() => orden('nombre')}>{loc('Nombre')}</button>
											<ul className="listaordena">
												{ListParams.orden === 'nombre' &&
													<li><img src={asc} alt='ordena ascendente' /></li>
												}
												{ListParams.orden === 'nombre DESC' &&
													<li><img src={desc} alt='ordena descendente' /></li>
												}
											</ul>
										</th>
										<th className='ocultamovil'>
											<button onClick={() => orden('ciudad')}>{loc('Ciudad')}</button>
											<ul className="listaordena">
												{ListParams.orden === 'ciudad' &&
													<li><img src={asc} alt='ordena ascendente' /></li>
												}
												{ListParams.orden === 'ciudad DESC' &&
													<li><img src={desc} alt='ordena descendente' /></li>
												}
											</ul>
										</th>
										<th>
											<button onClick={() => orden('asoc')}>{loc('Asociacion')}</button>
											<ul className="listaordena">
												{ListParams.orden === 'asoc' &&
													<li><img src={asc} alt='ordena ascendente' /></li>
												}
												{ListParams.orden === 'asoc DESC' &&
													<li><img src={desc} alt='ordena descendente' /></li>
												}
											</ul>
										</th>
										<th className='large-column'>
											<button onClick={() => orden('nAsociados')}>{loc('Asociados')}</button>
											<ul className="listaordena">
												{ListParams.orden === 'nAsociados' &&
													<li><img src={asc} alt='ordena ascendente' /></li>
												}
												{ListParams.orden === 'nAsociados DESC' &&
													<li><img src={desc} alt='ordena descendente' /></li>
												}
											</ul>
										</th>
										<th className='large-column'>
											<button onClick={() => orden('visible')}>{loc('Visible')}</button>
											<ul className="listaordena">
												{ListParams.orden === 'visible' &&
													<li><img src={asc} alt='ordena ascendente' /></li>
												}
												{ListParams.orden === 'visible DESC' &&
													<li><img src={desc} alt='ordena descendente' /></li>
												}
											</ul>
										</th>
									</tr>
								</thead>
								<tbody className='table-results'>
									{List.map((elem) => (
										<Fragment key={elem.idDojo} >
											<tr className={parseInt(elem.idDojo) === parseInt(idReg) ? 'selected' : ''}>
												{!showAcciones ? null : accionesPorDojo[elem.idDojo].length > 0 ? (
													<td className="table-button tiny-column">
														<div
															className="menu-wrapper"
															ref={(el) =>
																(menuRefs.current[elem.idDojo] = el)
															}>
															<OptionsIcon
																onClick={() => toggleMenu(elem.idDojo)}
																className="table-button__icon black"
															/>
															{activeMenu === elem.idDojo && (
																<FloatingMenu
																	anchorRef={{
																		current: menuRefs.current[elem.idDojo],
																	}}
																	onClose={() => setActiveMenu(null)}
																	id={elem.idDojo}>
																	{accionesPorDojo[elem.idDojo].map(
																		(accion, i) =>
																			accion.link ? (
																				<li key={i}>
																					<Link
																						className="no-decoration"
																						to={accion.href}>
																						{accion.icon}
																						<span>{accion.label}</span>
																					</Link>
																				</li>
																			) : (
																				<li key={i} onClick={accion.onClick}>
																					{accion.icon}
																					<span>{accion.label}</span>
																				</li>
																			)
																	)}
																</FloatingMenu>
															)}
														</div>
													</td>
												) : (
													<td className="table-button tiny-column">
														<OptionsIcon
															onClick={() => toggleMenu(elem.idCurso)}
															className="table-button__icon black disable-actions"
														/>
													</td>
												)}
												<td>
													<div className='fixposition'>
														<p className="fixsangria">{elem.nombre}</p>
													</div>
												</td>
												<td className='ocultamovil'>{elem.ciudad}</td>
												<td className='ajustawdmovil'><p>{elem.asoc}</p>
													<div className='detalles'>
														{Detalles !== elem.idDojo ?
															<button onClick={() => setDetalles(elem.idDojo)}><img src={despliega} alt="despliega" /></button>
															:
															<button onClick={() => setDetalles(0)}><img src={pliega} alt="pliega" /></button>
														}
													</div>
												</td>
												<td className='large-column'>
													{elem.numAsoc}
												</td>
												<td className='large-column'>
													{elem.visible ? loc("SI"):loc("NO")}
												</td>
											</tr>
										</Fragment>

									))

									}
								</tbody>
							</table>
						</div>
						{(perfil_admin | perfil_adm_asoc) ?
							<div>
								<button className="cta" onClick={() => setVerMod(-1)}>
									<span>
										{ListParams?.idAsoc ?? false ?
											loc('Añadir nuevo dojo a: ') + (ListParams?.nomAso ?? '')
											:
											loc('Añadir nuevo dojo')
										}
									</span>
									<MasIcon alt={loc('Añadir')} />
								</button>
							</div>
							: ''
						}
						<DojosMod
							show={VerMod}
							ListParams={ListParams}
							setListParams={setListParams}
							onHide={() => setVerMod(0)}
						/>
					</div>
				)}
			</div>
		</>
	)
}

export default Dojos